import { render, staticRenderFns } from "./cardList.vue?vue&type=template&id=4c646780&scoped=true"
import script from "./cardList.vue?vue&type=script&lang=js"
export * from "./cardList.vue?vue&type=script&lang=js"
import style0 from "./cardList.vue?vue&type=style&index=0&id=4c646780&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c646780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c646780')) {
      api.createRecord('4c646780', component.options)
    } else {
      api.reload('4c646780', component.options)
    }
    module.hot.accept("./cardList.vue?vue&type=template&id=4c646780&scoped=true", function () {
      api.rerender('4c646780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/cardList.vue"
export default component.exports